import Link from "next/link";
import { memo } from "react";

function TransparentButton({ val, link }) {
  return (
    <Link passHref href={link}>
      <a>
      <button className="py-2 px-5 rounded-full outline-none text-white border-2 border-solid border-primary-yellow bg-primary-yellow text-base font-semibold transition-all duration-700 ease-out hover:ease-in hover:bg-transparent hover:text-primary-yellow">
        <span>{val}</span>
      </button>
      </a>
    </Link>
  );
}

export default memo(TransparentButton);
